import PaymentsCard from 'components/PaymentsCard';
import { ContentHeading } from 'components/Typography';
import ChargesLineItem from 'components/ChargesLineItem';

export interface PropertyChargesProps {
  penalty: Array<{
    amount: string;
    currency: string;
  }>;
}

const PropertyCharges = ({ penalty }: PropertyChargesProps) => {
  return penalty.length > 0 ? (
    <>
      <ContentHeading>Charges & penalties</ContentHeading>
      <PaymentsCard mb={8}>
        <ChargesLineItem penalty={penalty} />
      </PaymentsCard>
    </>
  ) : null;
};

export default PropertyCharges;
